export default __webpack_public_path__ + "static/google-de-49f48a7fb22c9d705793cbf4504631ae.png";